import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles';
import { Paper, Grid, Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TechStatusIcon from './TechStatusIcon';


const WhiteIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.background.paper,
    '&:hover': {
        backgroundColor: theme.palette.getContrastText(theme.palette.background.paper),
    },
}));

const WhiteTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.background.paper,

}));

const TechProjectInfo = ({ project, handleGoBack }) => {
    const [techStatus, setTechStatus] = useState(null);



    useEffect(() => {
        if (project) {
            if (project?.techGrade && project?.techGrade > 0) {
                setTechStatus(project.techStatus);
            } else {
                setTechStatus('Pre-Sales');
            }
        }
    }, [project])


    return (
        <Paper sx={{
            mx: 2
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                backgroundColor: '#424242',

            }}>
                <Box sx={{ p: 1 }}>
                    <WhiteIconButton size="small" onClick={handleGoBack} >
                        <ArrowBackIcon aria-label="goBack" />
                    </WhiteIconButton>
                </Box>
                <Box
                    sx={{
                        py: 1,
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }}
                >

                    {project?.techGrade && (<TechStatusIcon project={project} />)}
                    <Box sx={{ ml: 2 }}>
                        <WhiteTypography variant="subtitle2" component="div">
                            현재 단계: {techStatus}
                        </WhiteTypography>

                        <WhiteTypography variant="subtitle1" component="div">
                            {project.cstNm}
                        </WhiteTypography>
                    </Box>
                </Box>
            </Box>
            <Box className="summary-grid-table" sx={{ px: 2, py: 2 }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={1} align="center">
                        <Typography variant="subtitle2" component="div" >
                            기회 구분
                        </Typography>
                    </Grid>
                    <Grid item xs={3} align="center">
                        <Typography variant="subtitle2" component="div" >
                            프로젝트 번호
                        </Typography>
                    </Grid>
                    <Grid item xs={3} align="center">
                        <Typography variant="subtitle2" component="div" >
                            고객명
                        </Typography>
                    </Grid>
                    <Grid item xs={3} align="center">
                        <Typography variant="subtitle2" component="div" >
                            매출(수금)예정일
                        </Typography>
                    </Grid>
                    <Grid item xs={2} align="center">
                        <Typography variant="subtitle2" component="div" >
                            예상 금액
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={1} align="center">
                        <Typography variant="body2" component="div" >
                            {project?.chanceTyp}
                        </Typography>
                    </Grid>
                    <Grid item xs={3} align="center">
                        <Typography variant="body2" component="div" >
                            {project?.prjNo}
                        </Typography>
                    </Grid>
                    <Grid item xs={3} align="center">
                        <Typography variant="body2" component="div" >
                            {project?.partnerInc}
                        </Typography>
                    </Grid>
                    <Grid item xs={3} align="center">
                        <Typography variant="body2" component="div" >
                            {(project.expDay) ? (project?.expDay) : `-`}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} align="center">
                        <Typography variant="body2" component="div" >
                            {(project.expSales) ? (`₩ ${project?.expSales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`) : `-`}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

        </Paper>
    )
}

export default TechProjectInfo